module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Deadly Highway")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About The Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#chapter-one"
    }
  }, [_vm._v("Chapter One")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#the-teenagers"
    }
  }, [_vm._v("The Teenagers")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#chapter-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#reported-missing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reported Missing")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#chapter-three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#the-found-body",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Found Body")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#chapter-four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#the-teenagers-second-escapade",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Teenagers Second Escapade")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#chapter-five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-worrying-parents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Worrying Parents")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#chapter-six",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-second-body",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Body")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#chapter-seven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#the-third-victim",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Victim")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#chapter-eight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#the-parents-decision",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Parent’s Decision")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#chapter-nine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#another-discovery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Discovery")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#chapter-ten",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#the-twist-of-a-kill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Twist of a Kill")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#chapter-eleven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#the-travelling-parents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Travelling Parents")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#chapter-twelve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#the-young-groups-fright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Young Groups Fright")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#chapter-thirteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#the-awful-surprise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Awful Surprise")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#chapter-fourteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#the-lucky-groom-to-be",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lucky Groom to Be")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#chapter-fifteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#the-girls-escape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Girl’s Escape")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#chapter-sixteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#grahams-capture",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham’s Capture")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#chapter-seventeen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#grahams-interview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham’s Interview")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#chapter-eighteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#the-girls-get-the-blame",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Girl’s get the Blame")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#chapter-nineteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#grahams-court-case",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham’s Court Case")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#chapter-twenty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#grahams-escape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham’s Escape")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#chapter-twenty-one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#the-death-of-the-girls",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Death of the Girls")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#chapter-twenty-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#graham-is-recaptured",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham is Recaptured")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#chapter-twenty-three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#grahams-second-trial",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham’s Second Trial")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0